<template>
  <VDialog
    v-model="visible"
    width="1000"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
    content-class="overflow-x-hidden"
  >
    <template #activator="{}">
      <slot name="activator" :show="show">
        <div class="d-flex">
          <VBtn
            text
            color="primary"
            class="mx-auto mx-md-0 mb-2"
            elevation="0"
            :disabled="disabled"
            @click="show"
          >
            <VIcon color="primary" small>
              mdi-plus
            </VIcon>
            <span class="pseudo-link primary--text d-inline-block ml-1 body-2">
              {{ $t('addQuestion') }}
            </span>
          </VBtn>
        </div>
      </slot>
    </template>

    <VCard class="grey lighten-5">
      <VContainer class="pa-0 pa-md-5">
        <VCardTitle
          class="pa-0 pt-4 pt-md-2 px-md-4"
          :class="{'white': $vuetify.breakpoint.smAndDown}"
        >
          <div class="step-title mb-0 mb-md-2">
            {{ $t('additional') }}
          </div>
          <div class="step-subtitle">
            {{ $t('subhead') }}
          </div>
          <VBtn
            icon
            small
            absolute
            top
            right
            class="d-flex"
            style="z-index: 5;"
            @click="close"
          >
            <Close />
          </VBtn>
        </VCardTitle>
        <VCardText class="pb-0">
          <VacancyQuestionsLibrary
            :categories="categories"
            @update="setSelectedQuestions"
            @save="next"
            :questions="questions"
            :selected="selectedQuestions"
            :vacancy-id="vacancyId"
            :show-preview="showPreview"
            :is-ai-questions="isAiQuestions"
          />
        </VCardText>
      </VContainer>
      <VCardActions class="white">
        <VContainer class="d-flex p-0 pa-md-4">
          <VBtn
            class="mr-auto mr-md-2"
            outlined
            color="success"
            @click="close"
          >
            {{ $t('cancel') }}
          </VBtn>
          <VBtn
            color="success"
            elevation="0"
            @click="next"
          >
            {{ $t('save') }}
          </VBtn>
        </VContainer>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import VacancyQuestionsLibrary from '@/components/Vacancy/VacancyQuestionsLibrary';
import Close from '@/components/SvgIcons/Close';
import VacancyScript from '@/orm/models/Interview/VacancyScript';
import { prepareQuestions } from '@/helpers/questions';
import Vacancy from '@/orm/models/Vacancy/Vacancy';
import ValidationMixin from '../../mixins/ValidationMixin';

export default {
  name: 'VacancyQuestionsLibraryDialog',
  components: { Close, VacancyQuestionsLibrary },
  mixins: [ValidationMixin],
  model: {
    prop: 'selected',
    event: 'update',
  },
  props: {
    visibility: {
      type: Boolean,
      default: false,
    },
    vacancyId: {
      type: Number,
      required: true,
    },
    interviewerId: {
      type: Number,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    showPreview: {
      type: Boolean,
      default: true,
      required: false,
    },
    isAiQuestions: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      visible: this.visibility,
      selectedQuestions: [...this.selected],
    };
  },
  computed: {
    vacancy() {
      return Vacancy.query().withAllRecursive().find(this.vacancyId);
    },
  },
  watch: {
    selected() {
      this.selectedQuestions = [...this.selected];
    },
  },
  methods: {
    setSelectedQuestions(questions) {
      this.selectedQuestions = questions;
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async submit() {
      this.$emit('update', this.selectedQuestions);
      await this.withValidationHandling(async () => {
        await VacancyScript.api().store(this.vacancyId, {
          interviewer: this.interviewerId,
          questions: prepareQuestions(this.selectedQuestions),
        });
      });
    },
    async next() {
      // await this.submit();
      this.$emit('update', this.selectedQuestions);
      this.close();
    },
    async back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-height {
  max-height: 400px;
}
.step-title {
  width: 100%;
}

.tree-view {
  &::v-deep {
    .v-treeview-node__content {
      cursor: pointer;
    }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .tree-view {
    overflow: initial;
    max-height: none !important;
  }
  .mobile-container {
    width: calc(100% + 24px);
    margin-left: -12px;
  }

}
</style>

<i18n locale="en" lang="yaml">
  addQuestion: Add question
  additional: Additional questions
  subhead: Do you want to ask a question? Try to find it in the library first.
  cancel: Cancel
  save: Save
</i18n>

<i18n locale="ru" lang="yaml">
  addQuestion: Добавить вопрос
  additional: Дополнительные вопросы
  subhead: Хотите задать вопрос? Попробуйте сперва найти его в библиотеке.
  cancel: Отмена
  save: Сохранить
</i18n>
